import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const vueRouter = new Router({
    $breadCrumbs: ['main'],
    mode: "hash",//history mode is not fit for netlify cloud
    routes: [
        {
            path: "/",
            name: "home",
            meta: {
                title: "Home"
            },
            component: () => import("./components/PageHome.vue"),
        },

        {
            path: "/login",
            name: "login",
            meta: {
                title: "Login"
            },
            component: () => import("./components/PageLogin"),
        },
        {
            path: "/user",
            name: "user",
            meta: {
                title: "User"
            },
            component: () => import("./components/PageUser.vue"),
        },
        {
            path: "/register",
            name: "register",
            meta: {
                title: "Register"
            },
            component: () => import("./components/PageRegister.vue"),
        },

        {
            path: "/admin",
            name: "admin",
            meta: {
                title: "Admin"
            },

            component: () => import("./components/Admin"),
            redirect: {name: 'users'},
            children: [

                {
                    path: "usages",
                    name: "usages",
                    meta: {
                        breads: [{name: 'home', title: 'Home'}, {name: 'usage', title: 'Usage List'}],
                        title: "Usages"
                    },
                    component: () => import("./components/AdminUsages")
                },
                {
                    path: "tickets",
                    name: "tickets",
                    meta: {
                        breads: [{name: 'home', title: 'Home'}, {name: 'ticket', title: 'Ticket List'}],
                        title: "Ticket"
                    },
                    component: () => import("./components/AdminTickets.vue")
                },

                {
                    path: "users",
                    name: "users",
                    meta: {
                        breads: [{name: 'home', title: 'Home'}, {name: 'user', title: 'User List'}],
                        title: "Users"
                    },
                    component: () => import("./components/AdminUsers")
                },
                {
                    path: "nodes",
                    name: "nodes",
                    meta: {
                        breads: [{name: 'home', title: 'Home'}, {name: 'user', title: 'Node List'}],
                        title: "Nodes"
                    },
                    component: () => import("./components/AdminNodes")
                },

            ]
        }
    ]
});


export default vueRouter;